import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const archiveProductApi = createApi({
    reducerPath: "archiveProductApi",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getArchivedProducts: builder.query({
            query: () => `/Product/all-archived-product`,
            providesTags: ["archivedData"],
        }),
    }),
});

export const { useGetArchivedProductsQuery } = archiveProductApi;
